import React from "react";

import { Arrow, Body, Header, Hint } from "./components";
import { Player } from "src/components/common";
import { useMobile } from "./hooks";

export const Mobile = React.memo(() => {
  const { getInfoProps, values } = useMobile();
  return (
    <div {...getInfoProps()}>
      <Arrow />
      <div className={values.styles.content}>
        <Header />
        <Body />
      </div>
      <Player />
      <Hint />
    </div>
  );
});

Mobile.displayName = "Mobile";
